import { render, staticRenderFns } from "./PontoSigMapBox.vue?vue&type=template&id=79fa8a90&scoped=true&"
import script from "./PontoSigMapBox.vue?vue&type=script&lang=js&"
export * from "./PontoSigMapBox.vue?vue&type=script&lang=js&"
import style0 from "./PontoSigMapBox.vue?vue&type=style&index=0&id=79fa8a90&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79fa8a90",
  null
  
)

export default component.exports